var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.sComponent,_vm._b({tag:"component",class:_vm.css,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.$attrs,false),[(_vm.loading)?_c('b-spinner',{attrs:{"sm":""}}):_c('span'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }